import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${props => props.theme.spacing.s4};
`;

export default Container;
